import { Txt } from "@stenajs-webui/core";
import { ValueTableItem } from "@stenajs-webui/elements";
import type { FC, ReactNode } from "react";

import { ValueTableExpandableContent } from "../../../../../common-ui/ValueTableExpandableContent";

interface DetailsRowProps {
  className?: string;
  collapse: boolean;
  name: string;
  suffix?: ReactNode;
  value?: string;
}

export const DetailsRow: FC<DetailsRowProps> = ({
  className,
  name,
  value,
  suffix,
  collapse,
}) => (
  <ValueTableItem
    label={name}
    value={
      value ? (
        collapse ? (
          <ValueTableExpandableContent>
            <Txt className={className}>
              {value}
              {suffix}
            </Txt>
          </ValueTableExpandableContent>
        ) : (
          <Txt className={className}>
            {value}
            {suffix}
          </Txt>
        )
      ) : undefined
    }
  />
);
